import { FiltroSoggettoAnagrafeVO } from "./filtro-soggetto-anagrafeVO";
import { FiltroRecapitoAnagrafeVO } from "./filtro-recapito-anagrafeVO";
import { PaginazioneVO } from "../paginazioneVO";

export class FiltroRicercaAnagrafeVO {
  // tipoSoggetto:TipoSoggettoAnagrafeEnum; //TipoSoggettoAnagrafeEnum.CITTADINO;
  filtroSoggettoAnagrafeVO: FiltroSoggettoAnagrafeVO = new FiltroSoggettoAnagrafeVO();
  filtroRecapitoAnagrafeVO: FiltroRecapitoAnagrafeVO = new FiltroRecapitoAnagrafeVO();
  tipiRecapito: string;
  paginazione: PaginazioneVO;
}
